// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.po-details-page {
  padding: 1rem;
  animation: fadeIn 0.5s ease-in-out;
}

.po-details-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 32px;
  flex-wrap: wrap; /* For responsiveness */
  gap: 1rem;
}
.ttiimm {
  display: flex;
  /* background-color: cornflowerblue; */
}

.customer-info h2 {
  font-size: 14px;
  font-weight: 500;
  color: #8a92a6;
  margin: 0;
}

.customer-info h2 .back-link {
  cursor: pointer;
  transition: color 0.2s;
}
.customer-info h2 .back-link:hover {
  color: #ff8a00;
}

.customer-info h1 {
  font-size: 28px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 4px 0 0 0;
}

.generate-invoice-btn {
  background-color: #ff8a00;
  color: white;
  border: none;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.generate-invoice-btn:hover {
  background-color: #e67b00;
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(255, 138, 0, 0.3);
}

.generate-invoice-btn:disabled {
  background-color: #faddbb;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.cart-items-list {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.cart-item-card {
  /* background-color: #f9f9f9; */
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  padding: 24px;
}

.card-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px 32px;
}

.info-block label {
  display: block;
  font-size: 14px;
  color: #8a92a6;
  margin-bottom: 8px;
}

.info-block p {
  font-size: 16px;
  color: #3a445d;
  font-weight: 500;
  margin: 0;
}

.info-block--link a {
  color: #0062ff;
  text-decoration: none;
  word-break: break-all;
}
.info-block--link a:hover {
  text-decoration: underline;
}

.info-block--full {
  grid-column: 1 / -1;
}

.cost-block {
  grid-column: 1 / -1;
  border-top: 1px solid #f0f1f3;
  padding-top: 24px;
}

.cost-value {
  color: #ff8a00 !important;
  font-size: 24px !important;
  font-weight: 700 !important;
}

.action-block {
  grid-column: 1 / -1;
  border-top: 1px solid #f0f1f3;
  padding-top: 24px;
}

.generate-price-btn {
  background-color: transparent;
  color: #ff8a00;
  border: 1px solid #ff8a00;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.generate-price-btn:hover {
  background-color: #fff2d8;
}

/* Add these to the BOTTOM of PurchaseOrderDetailsPage.css */

/* Generic styles for the main action button */
.main-action-btn {
  background-color: #ff8a00;
  color: white;
  border: none;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}
.main-action-btn:hover:not(:disabled) {
  background-color: #e67b00;
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(255, 138, 0, 0.3);
}
.main-action-btn:disabled {
  background-color: #faddbb;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* Specific style for the green 'Approve' button */
.main-action-btn--approve {
  background-color: #00875a;
}
.main-action-btn--approve:hover:not(:disabled) {
  background-color: #00694a;
  box-shadow: 0 4px 10px rgba(0, 135, 90, 0.3);
}

.status-display {
  font-size: 16px;
  font-weight: 600;
  color: #3a445d;
  background-color: #f0f1f3;
  padding: 12px 24px;
  border-radius: 8px;
}

/* Payment Summary Card */
.payment-summary-card {
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  padding: 24px;
  margin-top: 24px;
}
.payment-summary-card h3 {
  margin-top: 0;
  margin-bottom: 16px;
  font-size: 18px;
}
.payment-summary-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  align-items: center;
  gap: 16px;
}

.view-details-btn {
  background-color: transparent;
  color: #0062ff;
  border: 1px solid #0062ff;
  justify-self: start;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}
.view-details-btn:hover {
  background-color: #e6f0ff;
}

/* Responsive Grid */
@media (max-width: 992px) {
  .card-grid {
    grid-template-columns: 1fr 1fr;
  }
}
@media (max-width: 768px) {
  .card-grid {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 600px) {
  .card-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  .payment-summary-card {
    padding: 12px;
  }
}

.cart-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

.cart-title {
  color: #ff6b35;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 20px;
}

.cart-item1 {
  /* background: #fff; */
  /* border: 1px solid #e5e7eb; */
  border-radius: 8px;
  margin-bottom: 20px;
  overflow: hidden;
}

.item-header {
  /* background: #f9fafb; */
  padding: 16px;
  /* border-bottom: 1px solid #e5e7eb; */
}

.header-row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 20px;
}

.header-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.label {
  font-size: 12px;
  color: #6b7280;
  font-weight: 500;
}

.value {
  font-size: 14px;
  color: #374151;
  font-weight: 600;
}

.link {
  font-size: 14px;
  color: #3b82f6;
  text-decoration: none;
  font-weight: 600;
}

.link:hover {
  text-decoration: underline;
}

.item-content1 {
  padding: 16px;
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 20px;
  /* background-color: #f9f9f9; */
}

.content-section {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.items-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.section-label {
  font-size: 12px;
  color: #6b7280;
  font-weight: 500;
}

.items-text {
  font-size: 14px;
  color: #374151;
  margin: 0;
  line-height: 1.4;
}

.cost-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.cost-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.cost-amount {
  font-size: 24px;
  font-weight: 700;
  color: #1e40af;
}

.update-btn1 {
  border: 1px solid #ff6600;
  border-radius: 20px;
  padding: 6px 16px;
  font-size: 12px;
  color: #ff6600;
  cursor: pointer;
  font-weight: 500;
}

.update-btn1:hover {
  background: #fde68a;
}

.details-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.details-text {
  font-size: 14px;
  color: #374151;
  margin: 0;
  line-height: 1.4;
}

@media (max-width: 768px) {
  .header-row {
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }

  .item-content1 {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .cost-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}

@media (max-width: 480px) {
  .header-row {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .cart-container {
    padding: 16px;
  }
}

.status-check-request {
  padding: 0px;
  color: #fbd500;
  background-color: #fffbe8;
  margin-left: 15px;
  border-radius: 5px;
  font-size: 20px;
}

.cart-con {
  padding: 6px;
  background-color: #fff0e6;
  color: #ff6600;
  width: 100px;
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.status-badge {
  margin-left: 12px;
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 14px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
}

/* Status Colors */
.bg-blue-100 {
  background-color: #dbeafe;
}
.text-blue-800 {
  color: #1e40af;
}

.bg-green-100 {
  background-color: #dcfce7;
}
.text-green-800 {
  color: #166534;
}

.bg-red-100 {
  background-color: #fee2e2;
}
.text-red-800 {
  color: #991b1b;
}

.bg-yellow-100 {
  background-color: #fef9c3;
}
.text-yellow-800 {
  color: #854d0e;
}

.bg-purple-100 {
  background-color: #f3e8ff;
}
.text-purple-800 {
  color: #6b21a8;
}

.bg-indigo-100 {
  background-color: #e0e7ff;
}
.text-indigo-800 {
  color: #3730a3;
}

.bg-gray-100 {
  background-color: #f3f4f6;
}
.text-gray-800 {
  color: #1f2937;
}
`, "",{"version":3,"sources":["webpack://./src/pages/PurchaseOrderDetailsPage/PurchaseOrderDetailsPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,eAAe,EAAE,uBAAuB;EACxC,SAAS;AACX;AACA;EACE,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,4DAA4D;;AAE5D,8CAA8C;AAC9C;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,6CAA6C;AAC/C;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,kDAAkD;AAClD;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,sBAAsB;EACtB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,2DAA2D;EAC3D,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE;IACE,8BAA8B;EAChC;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,8EAA8E;AAChF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE;IACE,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB","sourcesContent":[".po-details-page {\n  padding: 1rem;\n  animation: fadeIn 0.5s ease-in-out;\n}\n\n.po-details-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 32px;\n  flex-wrap: wrap; /* For responsiveness */\n  gap: 1rem;\n}\n.ttiimm {\n  display: flex;\n  /* background-color: cornflowerblue; */\n}\n\n.customer-info h2 {\n  font-size: 14px;\n  font-weight: 500;\n  color: #8a92a6;\n  margin: 0;\n}\n\n.customer-info h2 .back-link {\n  cursor: pointer;\n  transition: color 0.2s;\n}\n.customer-info h2 .back-link:hover {\n  color: #ff8a00;\n}\n\n.customer-info h1 {\n  font-size: 28px;\n  font-weight: 700;\n  color: #1a1a1a;\n  margin: 4px 0 0 0;\n}\n\n.generate-invoice-btn {\n  background-color: #ff8a00;\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  font-size: 16px;\n  font-weight: 600;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.generate-invoice-btn:hover {\n  background-color: #e67b00;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 10px rgba(255, 138, 0, 0.3);\n}\n\n.generate-invoice-btn:disabled {\n  background-color: #faddbb;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.cart-items-list {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.cart-item-card {\n  /* background-color: #f9f9f9; */\n  border-radius: 12px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);\n  padding: 24px;\n}\n\n.card-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 24px 32px;\n}\n\n.info-block label {\n  display: block;\n  font-size: 14px;\n  color: #8a92a6;\n  margin-bottom: 8px;\n}\n\n.info-block p {\n  font-size: 16px;\n  color: #3a445d;\n  font-weight: 500;\n  margin: 0;\n}\n\n.info-block--link a {\n  color: #0062ff;\n  text-decoration: none;\n  word-break: break-all;\n}\n.info-block--link a:hover {\n  text-decoration: underline;\n}\n\n.info-block--full {\n  grid-column: 1 / -1;\n}\n\n.cost-block {\n  grid-column: 1 / -1;\n  border-top: 1px solid #f0f1f3;\n  padding-top: 24px;\n}\n\n.cost-value {\n  color: #ff8a00 !important;\n  font-size: 24px !important;\n  font-weight: 700 !important;\n}\n\n.action-block {\n  grid-column: 1 / -1;\n  border-top: 1px solid #f0f1f3;\n  padding-top: 24px;\n}\n\n.generate-price-btn {\n  background-color: transparent;\n  color: #ff8a00;\n  border: 1px solid #ff8a00;\n  padding: 10px 20px;\n  font-size: 14px;\n  font-weight: 600;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.generate-price-btn:hover {\n  background-color: #fff2d8;\n}\n\n/* Add these to the BOTTOM of PurchaseOrderDetailsPage.css */\n\n/* Generic styles for the main action button */\n.main-action-btn {\n  background-color: #ff8a00;\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  font-size: 16px;\n  font-weight: 600;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n.main-action-btn:hover:not(:disabled) {\n  background-color: #e67b00;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 10px rgba(255, 138, 0, 0.3);\n}\n.main-action-btn:disabled {\n  background-color: #faddbb;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n/* Specific style for the green 'Approve' button */\n.main-action-btn--approve {\n  background-color: #00875a;\n}\n.main-action-btn--approve:hover:not(:disabled) {\n  background-color: #00694a;\n  box-shadow: 0 4px 10px rgba(0, 135, 90, 0.3);\n}\n\n.status-display {\n  font-size: 16px;\n  font-weight: 600;\n  color: #3a445d;\n  background-color: #f0f1f3;\n  padding: 12px 24px;\n  border-radius: 8px;\n}\n\n/* Payment Summary Card */\n.payment-summary-card {\n  background-color: #fff;\n  border-radius: 12px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);\n  padding: 24px;\n  margin-top: 24px;\n}\n.payment-summary-card h3 {\n  margin-top: 0;\n  margin-bottom: 16px;\n  font-size: 18px;\n}\n.payment-summary-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  align-items: center;\n  gap: 16px;\n}\n\n.view-details-btn {\n  background-color: transparent;\n  color: #0062ff;\n  border: 1px solid #0062ff;\n  justify-self: start;\n  padding: 10px 20px;\n  font-size: 14px;\n  font-weight: 600;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n.view-details-btn:hover {\n  background-color: #e6f0ff;\n}\n\n/* Responsive Grid */\n@media (max-width: 992px) {\n  .card-grid {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n@media (max-width: 768px) {\n  .card-grid {\n    grid-template-columns: 1fr;\n  }\n}\n@media (max-width: 600px) {\n  .card-grid {\n    grid-template-columns: 1fr;\n    gap: 12px;\n  }\n  .payment-summary-card {\n    padding: 12px;\n  }\n}\n\n.cart-container {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 20px;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n}\n\n.cart-title {\n  color: #ff6b35;\n  font-size: 18px;\n  font-weight: 600;\n  margin-bottom: 20px;\n}\n\n.cart-item1 {\n  /* background: #fff; */\n  /* border: 1px solid #e5e7eb; */\n  border-radius: 8px;\n  margin-bottom: 20px;\n  overflow: hidden;\n}\n\n.item-header {\n  /* background: #f9fafb; */\n  padding: 16px;\n  /* border-bottom: 1px solid #e5e7eb; */\n}\n\n.header-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr 1fr;\n  gap: 20px;\n}\n\n.header-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.label {\n  font-size: 12px;\n  color: #6b7280;\n  font-weight: 500;\n}\n\n.value {\n  font-size: 14px;\n  color: #374151;\n  font-weight: 600;\n}\n\n.link {\n  font-size: 14px;\n  color: #3b82f6;\n  text-decoration: none;\n  font-weight: 600;\n}\n\n.link:hover {\n  text-decoration: underline;\n}\n\n.item-content1 {\n  padding: 16px;\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  gap: 20px;\n  /* background-color: #f9f9f9; */\n}\n\n.content-section {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.items-section {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.section-label {\n  font-size: 12px;\n  color: #6b7280;\n  font-weight: 500;\n}\n\n.items-text {\n  font-size: 14px;\n  color: #374151;\n  margin: 0;\n  line-height: 1.4;\n}\n\n.cost-section {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.cost-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.cost-amount {\n  font-size: 24px;\n  font-weight: 700;\n  color: #1e40af;\n}\n\n.update-btn1 {\n  border: 1px solid #ff6600;\n  border-radius: 20px;\n  padding: 6px 16px;\n  font-size: 12px;\n  color: #ff6600;\n  cursor: pointer;\n  font-weight: 500;\n}\n\n.update-btn1:hover {\n  background: #fde68a;\n}\n\n.details-section {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.details-text {\n  font-size: 14px;\n  color: #374151;\n  margin: 0;\n  line-height: 1.4;\n}\n\n@media (max-width: 768px) {\n  .header-row {\n    grid-template-columns: 1fr 1fr;\n    gap: 16px;\n  }\n\n  .item-content1 {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n\n  .cost-row {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n}\n\n@media (max-width: 480px) {\n  .header-row {\n    grid-template-columns: 1fr;\n    gap: 12px;\n  }\n\n  .cart-container {\n    padding: 16px;\n  }\n}\n\n.status-check-request {\n  padding: 0px;\n  color: #fbd500;\n  background-color: #fffbe8;\n  margin-left: 15px;\n  border-radius: 5px;\n  font-size: 20px;\n}\n\n.cart-con {\n  padding: 6px;\n  background-color: #fff0e6;\n  color: #ff6600;\n  width: 100px;\n  margin-bottom: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.status-badge {\n  margin-left: 12px;\n  padding: 6px 12px;\n  border-radius: 16px;\n  font-size: 14px;\n  font-weight: 500;\n  display: inline-flex;\n  align-items: center;\n}\n\n/* Status Colors */\n.bg-blue-100 {\n  background-color: #dbeafe;\n}\n.text-blue-800 {\n  color: #1e40af;\n}\n\n.bg-green-100 {\n  background-color: #dcfce7;\n}\n.text-green-800 {\n  color: #166534;\n}\n\n.bg-red-100 {\n  background-color: #fee2e2;\n}\n.text-red-800 {\n  color: #991b1b;\n}\n\n.bg-yellow-100 {\n  background-color: #fef9c3;\n}\n.text-yellow-800 {\n  color: #854d0e;\n}\n\n.bg-purple-100 {\n  background-color: #f3e8ff;\n}\n.text-purple-800 {\n  color: #6b21a8;\n}\n\n.bg-indigo-100 {\n  background-color: #e0e7ff;\n}\n.text-indigo-800 {\n  color: #3730a3;\n}\n\n.bg-gray-100 {\n  background-color: #f3f4f6;\n}\n.text-gray-800 {\n  color: #1f2937;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
